var auditLogMap = {
  id: 'id',
  event_type: 'eventType',
  object_type: 'objectType',
  object_id: 'objectId',
  data: 'data',
  user_id: 'userId',
  created_at: 'createdAt',
  updated_at: 'updatedAt'
};
export default auditLogMap;